import { isAxiosError } from "axios";
import i18n, { t } from "i18next";
import axios from "../lib/axios";

export async function fetchNotifications(language: string) {
  try {
    const response = await axios.get(`/api/notifications`, {
      params: {
        language,
      },

      headers: {
        "Accept-Language": i18n.language,
      },
    });

    return {
      isOk: true,
      message:
        response.data.message ||
        t("Information download completed successfully"),
      data: response.data,
    };
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    return {
      isOk: false,
      error: message,
    };
  }
}

export async function markNotificationAsRead(id: number): Promise<void> {
  try {
    await axios.patch(`api/notifications/${id}/mark-as-read`, undefined, {
      headers: {
        "Accept-Language": i18n.language,
      },
    });
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    throw new Error(message);
  }
}
